import { render, staticRenderFns } from "./selectUnitOther.vue?vue&type=template&id=1486f877"
import script from "./selectUnitOther.vue?vue&type=script&lang=js"
export * from "./selectUnitOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports